import { createBrowserRouter } from 'react-router-dom'

import Layout from './components/Layout/Layout'
import Index from './pages/Index'
import Links from './pages/Links'
import Notfound from './pages/Notfound'

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <Layout>
        <Index />
      </Layout>
    ),
  },
  {
    path: '/links',
    element: (
      <Layout>
        <Links />
      </Layout>
    ),
  },
  {
    path: '*',
    element: (
      <Layout>
        <Notfound />
      </Layout>
    ),
  },
])

export default router
